// Event delegation keeps navigation working after Shopify editor section reloads.
const setHoleyMenu = (open) => {
  const toggle = document.querySelector('[data-menu-toggle]');
  const menu = document.getElementById('holey-menu');
  const backdrop = document.querySelector('.menu-backdrop');
  if (!menu || !toggle || !backdrop) return;
  menu.classList.toggle('is-open', open);
  menu.setAttribute('aria-hidden', String(!open));
  menu.inert = !open;
  backdrop.hidden = !open;
  toggle.setAttribute('aria-expanded', String(open));
  document.body.classList.toggle('menu-open', open);
  if (open) menu.querySelector('[data-menu-close]')?.focus();
  else toggle.focus();
};
document.addEventListener('click', event => {
  if (event.target.closest('[data-menu-toggle]')) setHoleyMenu(true);
  else if (event.target.closest('[data-menu-close], #holey-menu a')) setHoleyMenu(false);
});
document.addEventListener('keydown', event => {
  const menu = document.getElementById('holey-menu');
  if (event.key === 'Escape' && menu?.classList.contains('is-open')) setHoleyMenu(false);
});
document.addEventListener('shopify:section:unload', () => {
  document.body.classList.remove('menu-open');
});

const productCleanups = new WeakMap();
function initHoleyProduct(root = document) {
  const section = root.querySelector('[data-product-section]');
  if (!section || section.dataset.initialized) return;
  const form = section.querySelector('#holey-product-form');
  const select = form?.querySelector('[data-variant-select]');
  if (!select) return;
  section.dataset.initialized = 'true';
  const controller = new AbortController(), events = { signal: controller.signal };
  const on = (el, name, fn) => el?.addEventListener(name, fn, events);
  const options = [...select.options];
  const copy = JSON.parse(section.querySelector('[data-holey-copy]')?.textContent || '{}');
  const gallery = section.querySelector('.product-gallery');
  const modelSelect = form.querySelector('[data-model-select]');
  const sizes = form.querySelector('[data-sizes]');
  const fit = form.querySelector('[data-fit-note]');
  const property = form.querySelector('[data-size-property]');
  const add = form.querySelector('[data-add-button]');
  const stickyAdd = section.querySelector('[data-sticky-add]');
  let pointure = null, choices = [], currentModel = '';
  const modelOf = o => o.dataset.model || `variant-${o.value}`;
  const models = [...new Set(options.map(modelOf))];
  const isKnown = o => o.dataset.min !== '' && o.dataset.max !== '' && Number(o.dataset.min) >= 20 && Number(o.dataset.max) <= 60 && Number(o.dataset.max) >= Number(o.dataset.min);
  const expand = section.dataset.expandSizes !== 'false';
  const showMedia = id => {
    if (!gallery || !id) return;
    const frameId = `media-${id}`;
    if (![...gallery.querySelectorAll('.media-frame')].some(f => f.id === frameId)) return;
    gallery.querySelectorAll('.media-frame').forEach(frame => frame.classList.toggle('hidden', frame.id !== frameId));
    gallery.querySelectorAll('[data-media-target]').forEach(b => b.classList.toggle('selected', b.dataset.mediaTarget === frameId));
    gallery.querySelectorAll('video').forEach(v => { if (v.closest('.hidden')) v.pause(); });
  };
  gallery?.querySelectorAll('[data-media-target]').forEach(b => on(b, 'click', () => showMedia(b.dataset.mediaTarget.replace('media-', ''))));
  const packButtons = [...form.querySelectorAll('[data-pack-quantity]')];
  const quantityInput = form.elements.quantity;
  const money = new Intl.NumberFormat(document.documentElement.lang || 'fr', {style:'currency', currency:section.dataset.currency || 'CHF'});
  const refreshPacks = () => {
    const o = select.selectedOptions[0];
    const cents = Number(o?.dataset.priceCents);
    if (!Number.isFinite(cents)) return;
    const qty = Math.max(1, Math.floor(Number(quantityInput.value) || 1));
    packButtons.forEach(button => {
      const count = Number(button.dataset.packQuantity);
      button.setAttribute('aria-pressed', String(qty === count));
      button.querySelector('[data-pack-price]').textContent = money.format(cents * count / 100);
    });
    section.querySelectorAll('[data-product-price], [data-sticky-price]').forEach(el => el.textContent = money.format(cents * qty / 100));
  };
  packButtons.forEach(button => on(button, 'click', () => { quantityInput.value = button.dataset.packQuantity; refreshPacks(); }));
  section.querySelectorAll('[data-open-detail]').forEach(link => on(link, 'click', () => {
    const detail = section.querySelector('#' + link.dataset.openDetail); if (detail) detail.open = true;
  }));
  const update = (o, changeURL = true) => {
    if (!o) return;
    select.value = o.value;
    const needsSize = choices.some(c => c.size != null) && pointure === null;
    const available = o.dataset.available === 'true';
    const buttonText = needsSize ? 'CHOISIS TA POINTURE' : available ? 'AJOUTER AU PANIER' : 'ÉPUISÉ';
    // The button remains actionable until a size is chosen, to take keyboard/mobile users to the picker.
    add.disabled = !needsSize && !available;
    if (stickyAdd) stickyAdd.disabled = add.disabled;
    section.querySelectorAll('[data-add-label], [data-sticky-label]').forEach(el => el.textContent = buttonText);
    section.querySelectorAll('[data-active-price], [data-product-price], [data-sticky-price]').forEach(el => el.textContent = o.dataset.price);
    const comparison = section.querySelector('[data-compare-price]');
    if (comparison) { comparison.textContent = o.dataset.comparePrice; comparison.hidden = o.dataset.discount !== 'true'; }
    const c = copy[o.value];
    if (c) {
      const heading = section.querySelector('[data-model-title]');
      const parts = c.title.split(' — ');
      const name = document.createElement('span'); name.textContent = parts[0]; heading.replaceChildren(name);
      if (parts.length > 1) { const kind = document.createElement('span'); kind.className = 'holey-product-kind'; kind.textContent = parts.slice(1).join(' — '); heading.append(kind); }
      section.querySelector('[data-model-intro]').textContent = c.intro;
      section.querySelector('[data-model-collection]').textContent = c.collection;
      section.querySelector('[data-model-body]').innerHTML = c.body;
      form.querySelector('[data-model-property]').value = c.title;
    }
    property.disabled = pointure === null; property.value = pointure ?? '';
    fit.textContent = pointure !== null ? `Ta pointure : ${pointure}. Tu recevras le modèle extensible ${o.dataset.size}.` : isKnown(o) ? `Ce modèle est proposé en plages de pointures. Choisis la tienne ci-dessus.` : 'Taille unique. Besoin de vérifier si elle te convient ? Contacte-nous avant de commander.';
    showMedia(o.dataset.mediaId);
    refreshPacks();
    if (changeURL) {
      const url = new URL(window.location.href); url.searchParams.set('variant', o.value); history.replaceState(null, '', url);
    }
  };
  const build = (model, preferred) => {
    currentModel = model; modelSelect.value = model; pointure = null;
    const group = options.filter(o => modelOf(o) === model);
    choices = [];
    if (expand && group.every(isKnown)) {
      // Stable overlap rule: e.g. 39 always uses 35–39, not whichever variant has more stock.
      const ordered = [...group].sort((a,b) => Number(a.dataset.min)-Number(b.dataset.min) || Number(a.dataset.max)-Number(b.dataset.max));
      const bySize = new Map();
      ordered.forEach(o => { for (let n=Number(o.dataset.min);n<=Number(o.dataset.max);n++) if (!bySize.has(n)) bySize.set(n,o); });
      choices = [...bySize].sort((a,b)=>a[0]-b[0]).map(([size,o])=>({size,o,label:String(size)}));
    } else choices = group.map(o=>({size:null,o,label:o.dataset.model ? o.dataset.size : o.textContent.trim()}));
    sizes.replaceChildren();
    form.querySelector('[data-size-legend]').textContent = choices.some(c=>c.size!==null) ? 'Choisis ta pointure' : 'Taille';
    const selected = group.find(o=>o.value===preferred) || group.find(o=>o.dataset.available==='true') || group[0];
    choices.forEach(choice => {
      const button=document.createElement('button');button.type='button';button.textContent=choice.label;
      button.disabled=choice.o.dataset.available!=='true';
      button.setAttribute('aria-pressed',String(choice.size===null && choice.o===selected));
      button.setAttribute('aria-label', `${choice.label}${choice.size!==null ? `, modèle ${choice.o.dataset.size}` : ''}${button.disabled ? ', épuisé' : ''}`);
      on(button,'click',()=>{
        pointure=choice.size;
        sizes.querySelectorAll('button').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
        update(choice.o);
      });sizes.append(button);
    });
    update(selected, false);
  };
  models.forEach(model=>{const o=options.find(o=>modelOf(o)===model);const opt=document.createElement('option');opt.value=model;opt.textContent=o.dataset.title;modelSelect.append(opt);});
  form.querySelector('[data-model-picker]').hidden=models.length<2;
  on(modelSelect,'change',()=>{build(modelSelect.value); update(select.selectedOptions[0]);});
  on(select,'change',()=>build(modelOf(select.selectedOptions[0]),select.value));
  on(window,'popstate',()=>{const o=options.find(o=>o.value===new URL(location.href).searchParams.get('variant'));if(o)build(modelOf(o),o.value);});
  build(modelOf(select.selectedOptions[0]),select.value);
  form.querySelector('[data-native-picker]').hidden=true;
  form.querySelector('[data-enhanced-picker]').hidden=false;
  if (packButtons.length) {
    form.querySelector('[data-pack-picker]').hidden=false;
    form.querySelector('[data-manual-quantity]').hidden=true;
  }
  on(quantityInput,'input',refreshPacks);
  on(form.querySelector('[data-qty-minus]'),'click',()=>{const i=form.elements.quantity;i.value=Math.max(1,Math.floor(Number(i.value)||1)-1);refreshPacks();});
  on(form.querySelector('[data-qty-plus]'),'click',()=>{const i=form.elements.quantity;i.value=Math.max(1,Math.floor(Number(i.value)||1)+1);refreshPacks();});
  on(form,'submit',event=>{
    if (choices.some(c=>c.size!==null) && pointure===null) {
      event.preventDefault();sizes.scrollIntoView({block:'center',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
      sizes.querySelector('button:not(:disabled)')?.focus();fit.textContent='Choisis ta pointure avant d’ajouter cette paire au panier.';
    } else if (select.selectedOptions[0]?.dataset.available!=='true') event.preventDefault();
    // Native Shopify product form posts the ORIGINAL variant ID, quantity and optional properties.
  });
  const sticky=section.querySelector('[data-product-sticky]'),purchase=form.querySelector('[data-main-purchase]');let frame=0;
  const updateSticky=()=>{if(!sticky)return;const show=matchMedia('(max-width:700px)').matches && purchase.getBoundingClientRect().bottom<0;sticky.hidden=!show;document.body.classList.toggle('has-mobile-buy-bar',show);};
  const schedule=()=>{if(!frame)frame=requestAnimationFrame(()=>{frame=0;updateSticky();});};
  window.addEventListener('scroll',schedule,{passive:true,signal:controller.signal});on(window,'resize',schedule);updateSticky();
  productCleanups.set(section,()=>{controller.abort();cancelAnimationFrame(frame);document.body.classList.remove('has-mobile-buy-bar');});
}
function initHoleyCatalogue(root=document) {
  root.querySelectorAll('[data-holey-catalogue]').forEach(section=>{
    if(section.dataset.initialized)return;section.dataset.initialized='true';
    const cards=[...section.querySelectorAll('[data-holey-card]')],search=section.querySelector('[data-catalogue-search]');
    const allowed=['all','other','snack-socks','sushiiiiii','fast-food','sugar-sugar','cartoonies','limited-edition'];
    let selected=section.dataset.defaultFilter || 'all';
    const param=new URL(location.href).searchParams.get('holey');if(allowed.includes(param))selected=param;
    const links=[...section.querySelectorAll('[data-filter]')];
    const apply=()=>{
      let count=0;const query=(search?.value||'').toLocaleLowerCase('fr');
      cards.forEach(card=>{const visible=(selected==='all'||(selected==='other'&&['cartoonies','limited-edition'].includes(card.dataset.collection))||card.dataset.collection===selected||card.dataset.range===selected)&&card.textContent.toLocaleLowerCase('fr').includes(query);card.hidden=!visible;if(visible)count++;});
      const food=['snack-socks','sushiiiiii','fast-food','sugar-sugar'].includes(selected);
      const other=['other','cartoonies','limited-edition'].includes(selected);
      links.forEach(a=>a.setAttribute('aria-current',String(a.dataset.filter===selected||(a.dataset.filterFamily==='food'&&food)||(a.dataset.filterFamily==='other'&&other))));
      section.querySelectorAll('[data-filter-subgroup]').forEach(n=>n.hidden=n.dataset.filterSubgroup==='food'?!food:!other);
      const labels={all:['Toutes les chaussettes','Food, dessins ou effet délavé : choisis ton univers, puis ta paire.'],'snack-socks':['Snack & socks','Les chaussettes food : sushis, fast-food et douceurs. À porter, pas à manger.'],other:['Motifs & délavé','Cartoonies pour les dessins. Limited edition pour les couleurs délavées.'],sushiiiiii:['Sushiiiiii','Des chaussettes sushi. Le Japon descend dans tes baskets.'],'fast-food':['Fast food','Burgers, pizzas et snacks. À emporter aux pieds.'],'sugar-sugar':['Sugar sugar','Glaces et douceurs. La gourmandise, jusqu’aux orteils.'],cartoonies:['Cartoonies','Des chaussettes à dessins. Pour les pieds qui ont des choses à raconter.'],'limited-edition':['Limited edition','Des chaussettes à effet délavé. Les couleurs font ce qu’elles veulent.']};
      const heading=section.querySelector('[data-catalogue-heading]'),description=section.querySelector('[data-catalogue-description]');
      if(heading)heading.textContent=labels[selected][0];if(description)description.textContent=labels[selected][1];
      const counter=section.querySelector('[data-catalogue-count]');if(counter)counter.textContent=`${count} modèle${count>1?'s':''}`;
      const empty=section.querySelector('[data-catalogue-empty]');if(empty)empty.hidden=count>0;
    };
    links.forEach(a=>a.addEventListener('click',e=>{if(section.hasAttribute('data-local-catalogue')||e.metaKey||e.ctrlKey||e.shiftKey||e.altKey)return;e.preventDefault();selected=a.dataset.filter;const u=new URL(location.href);u.searchParams.set('holey',selected);history.replaceState(null,'',u);apply();}));
    search?.addEventListener('input',apply);apply();
  });
}
document.addEventListener('DOMContentLoaded',()=>{initHoleyProduct();initHoleyCatalogue();if(matchMedia('(prefers-reduced-motion: reduce)').matches)document.querySelectorAll('video[autoplay]').forEach(v=>v.pause());});
document.addEventListener('shopify:section:load',event=>{initHoleyProduct(event.target);initHoleyCatalogue(event.target);});
document.addEventListener('shopify:section:unload',event=>{const s=event.target.querySelector('[data-product-section]');if(s)productCleanups.get(s)?.();});
